import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import echarts from 'echarts'

import store from './store'
// import VueAMap from 'vue-amap'
import htmlToPdf from './utils/htmlToPdf';
// import htmlToPdf2 from './utils/htmlToPdf2';
import '@/assets/fonts/font.scss'
// Vue.prototype.$echarts = echarts
// Vue.use(VueAMap);
Vue.use(htmlToPdf);
// Vue.use(htmlToPdf2);
// VueAMap.initAMapApiLoader({
//   key: '43907582fdff3923b3317dce8c238b6c',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geolocation'],
//   v: '1.4.4'
// });
Vue.config.productionTip = false
Vue.use(ElementUI) 
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
